<template>
  <div>
    <!--If data exists and the device is mobile show app bar-->
    <v-app-bar
      v-if="Object.keys(detailedRace).length > 0 && isMobile"
      class="pa-3 raceinfo"
      width="auto"
      color="blue-grey lighten-4"
      app
      height="70"
    >
      <v-chip label class="primaryTxt" color="primaryCol mt-n3">
        <img
          :src="raceTypeImg[detailedRace.meeting.type]"
          :alt="detailedRace.meeting.type"
          width="36"
          class="logo mr-2"
          style="filter:invert(100%)"
        />
        <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis" class="headline font-weight-bold">
          <span>{{detailedRace.meeting.track.name}} </span>
          <span>R{{detailedRace.number}}</span>
        </div>
      </v-chip>
      <v-spacer></v-spacer>
      <v-toolbar-title class="text-right mt-n3">
      <span
        v-if="detailedRace.trackCondition != 'UNKNOWN_CONDITION'"
        class="ml-2 font-weight-bold"
        style="color: grey"
      >{{checkTrackCond(detailedRace.trackCondition)}}</span>
        <span class="ml-2 font-weight-bold primary--text">{{detailedRace.weather}}</span>
        <span class="ml-2 font-weight-bold">{{detailedRace.meeting.track.surface}}</span>
        <div class="caption font-weight-regular mr-2 mt-n1">
          Time:
          <b>{{format(new Date(detailedRace.startTime), 'h:mm a')}}</b>
        </div>
      </v-toolbar-title>
      <template v-slot:extension>
        <div class="mt-n1">
        <span class="primary--text">
          <h3>{{detailedRace.name}}</h3>
          <div class="heading-4 d-inline font-weight-regular mt-2 mr-2">
            D:
            <b>{{detailedRace.distance}}m</b>
          </div>
          <div class="heading-4 d-inline font-weight-regular mt-2 mr-2">
            C:
            <b>{{checkClass(detailedRace.class)}}</b>
          </div>
          <div class="heading-4 d-inline font-weight-regular mt-2 mr-2">
            P:
            <b>${{numeral(detailedRace.prizeMoney).format('0,0a')}}</b>
          </div>
        </span>
        </div>
      </template>
    </v-app-bar>
    <!--Coloured bar under app bar-->
    <div v-if="isMobile" style="height: 5px; width: 100%; position: fixed; z-index: 999; top: 115px;" class="primaryCol"></div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import numeral from 'numeral'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'RaceName',
  data () {
    return {
      numeral,
      format,
      tips: [],
      raceTypeImg: {
        HARNESS: '/img/race_types/DO_RaceType_Harness-BLACK.svg',
        GREYHOUND: '/img/race_types/DO_RaceType_Greyhounds-BLACK.svg',
        THOROUGHBRED: '/img/race_types/DO_RaceType_Gallops-BLACK.svg'
      }
    }
  },
  computed: {
    ...mapState(['detailedRace', 'gbsID']),
    ...mapGetters(['isMobile'])
  },
  methods: {
    greyhoundMeeting (data) {
      return data.meeting.type === 'GREYHOUND'
    },
    harnessMeeting (data) {
      return data.meeting.type === 'HARNESS'
    },
    shortenRail (string) {
      let shortenedString = string
      if (string.includes('metres')) {
        const newStr = string.split('metres')
        const newStr1 = newStr[0].trim()
        const newStr2 = newStr[1].trim()
        shortenedString = `${newStr1}m${newStr2}`
      }
      return shortenedString
    },
    checkClass: function (x) {
      if (x.includes('HANDICAP=TRUE')) {
        // eslint-disable-next-line no-unused-vars
        const [first, second] = x.split(',')
        return `${first}, HCP`
      }
      if (x.includes('HANDICAP=FALSE')) {
        // eslint-disable-next-line no-unused-vars
        const [first, second] = x.split(',')
        return `${first}, HCP`
      }
      return x
    },
    navColor: function (mappedNumber, raceNumber, raceStatus) {
      if (mappedNumber === raceNumber) {
        return '#666'
      } else if (raceStatus === 'OPEN') {
        return '#4caf50'
      } else {
        return '#ff5252'
      }
    },
    checkTrackCond: function (condition) {
      switch (condition) {
        case 'FIRM1':
          return 'Firm 1'
        case 'Firm1':
          return 'Firm 1'
        case 'FIRM2':
          return 'Firm 2'
        case 'Firm2':
          return 'Firm 2'
        case 'GOOD3':
          return 'Good 3'
        case 'Good3':
          return 'Good 3'
        case 'GOOD4':
          return 'Good 4'
        case 'Good4':
          return 'Good 4'
        case 'SOFT5':
          return 'Soft 5'
        case 'Soft5':
          return 'Soft 5'
        case 'SOFT6':
          return 'Soft 6'
        case 'Soft6':
          return 'Soft 6'
        case 'SOFT7':
          return 'Soft 7'
        case 'Soft7':
          return 'Soft 7'
        case 'HEAVY8':
          return 'Heavy 8'
        case 'Heavy8':
          return 'Heavy 8'
        case 'HEAVY9':
          return 'Heavy 9'
        case 'Heavy9':
          return 'Heavy 9'
        case 'HEAVY10':
          return 'Heavy 10'
        case 'Heavy10':
          return 'Heavy 10'
        case 'HEAVY11':
          return 'Heavy 11'
        case 'Heavy11':
          return 'Heavy 11'
        case 'SYNTHETIC' || 'Synthetic':
          return 'Synthetic'
        default:
          return condition
      }
    }
  },
  props: {
    raceFlucs: Object,
    raceComment: String
  }
}
</script>

<style scoped>
::v-deep .v-toolbar__content {
  padding: 0px 0px !important;
  height: 45px !important;
}
::v-deep .v-toolbar__extension {
  padding: 0px 0px !important;
}
.color-Firm {
  color: rgb(0, 204, 255);
}
.color-Firm1 {
  color: rgb(0, 204, 255);
}
.color-Firm2 {
  color: rgb(0, 204, 255);
}
.color-Good {
  color: rgb(0, 219, 0);
}
.color-Good3 {
  color: rgb(0, 219, 0);
}
.color-Good4 {
  color: rgb(0, 219, 0);
}
.color-Soft {
  color: rgb(224, 210, 56);
}
.color-Soft5 {
  color: rgb(224, 210, 56);
}
.color-Soft6 {
  color: rgb(224, 210, 56);
}
.color-Soft7 {
  color: rgb(224, 210, 56);
}
.color-Heavy {
  color: orange;
}
.color-Heavy8 {
  color: orange;
}
.color-Heavy9 {
  color: orange;
}
.color-Heavy10 {
  color: orange;
}
.color-Synthetic {
  color: purple;
}
.raceinfo {
  line-height: 25px;
  width: 100%;
  text-align: justify;
  font-size: 14px;
  background-color: white;
  box-shadow: 3px 5px 5px lightgrey;
}
</style>
